import { Component, OnInit, Input, Output, ViewChild, TemplateRef, HostListener, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/common/services/api.service';
import { OfferService } from '../offer.service';
import { ClientService } from 'src/app/client/client.service';
import { TemplateService } from '../../template/template.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { Router, ActivatedRoute } from '@angular/router';
import { WizardComponent } from 'angular-archwizard';
import { ToastrService } from 'ngx-toastr';
import { FileUploader } from 'ng2-file-upload';
import { AppSettings } from 'src/app/common/appsettings';
import { AppSettingsService } from 'src/app/common/appsettings.service';
import { ReportingService } from 'src/app/common/services/reporting.service';
import { DecimalPipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { fadeIn } from 'ng-animate';
declare var require;
const Swal = require('sweetalert2');

@Component({
    selector: 'app-new',
    templateUrl: './new.component.html',
    styleUrls: ['./new.component.scss']
})
export class NewComponent implements OnInit {
    @ViewChild(WizardComponent, null) wizardComponent: WizardComponent;
    public stepWizard: WizardComponent;
    @ViewChild('ruleValidation', null) rulesValidationResult: TemplateRef<any>;
    @ViewChild('integrityCheckList', null) checkListModal: TemplateRef<any>;
    @ViewChild('backendProcess', null) backendProcessModal: TemplateRef<any>;
    @Output() directPayClick = new EventEmitter();
    @Input() insurancedXPortal: string;
    offerexternalcde: any;
    status: any;
    DiscountCode: any;
    promotionCode: any; 
    wizard: any;
    stepCode: number = 0;
    client: any;
    referentials: any;
    integrityChecks: any;
    isCritical: any;
    documentCodes: any = [];
    offerCodes: any = [];
    stepCodes: Array<string> = [];
    clientWizard: any;
    isExpandedOfferCover: any = 0;
    isExpandedOffer: boolean = false;
    isExpandGroup: boolean = false;
    clientCode: any;
    defaultStep: number = 1;
    nextStepID: any;
    control: any;
    items: any = [];
    loadingDDLdata: boolean = false;
    requiredControls: Array<string> = [];
    offers: any;
    steps: any;
    covers: any;
    sections: any;
    step: any;
    appliedDiscount: any = {};
    checkCodeSave: boolean = false;
    itemFields: any = {};
    coverFields: any = {};
    criteria: any = {};

    newOfferProcessCode: any;
    newLeadProcessCode: any;
    clientModificationProcessCode: any;
    consultClientProcessCode: any;
    newClientProcessCode: any;
    newPolicyProcessCode: any;
    settings: AppSettings;

    decimals: string = '';
    isSummary: boolean = false;

    appliedPromotion: any = {};
    constructor(private apiService: ApiService,
        private modalService: NgbModal,
        public translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private offerService: OfferService,
        private clientService: ClientService,
        private templateService: TemplateService,
        private toastrService: ToastrService,
        private appSettingsService: AppSettingsService,
        private reportingService: ReportingService,
        private decimalPipe: DecimalPipe,
        private spinner: NgxSpinnerService)
    {
        this.newLeadProcessCode = this.offerService.clientNewLead;
        this.newOfferProcessCode = this.offerService.clientNewOffer;
        this.newClientProcessCode = this.offerService.clientNewClient;
        this.clientModificationProcessCode = this.offerService.clientModification;
        this.consultClientProcessCode = this.offerService.clientConsultation
        this.newPolicyProcessCode = this.offerService.clientNewPolicy;

        this.clientCode = this.offerService.clientCode;
        this.loadTemplate();

    }

    ngOnInit() {
    }

    public uploader: FileUploader = new FileUploader({
        isHTML5: true,
        allowedMimeType: ['image/jpeg', 'image/png']
    });

    loadTemplate() {

        var model = {};
        if (this.offerService.offerHeaderKey && this.offerService.versionNo)
        {
            model = {
                "OfferHeaderKey": this.offerService.offerHeaderKey,
                "VersionNo": this.offerService.versionNo
            }
            
            this.apiService.post("Api/QuoteAPI/Get/", model).subscribe((res: any) => {
                this.wizard = res;
                this.referentials = res.Referentials;
                this.wizard.ProgressCount = 0;
                this.decimals = "1." + res.CurrencyDecimals + "-" + res.CurrencyDecimals + "";
                this.updateStepOfferDocumentCodes(); // update the **codes property
  //              this.populateDDControls(); //to populated the dropdown control values
  //              this.executeScript(); //Onload script execution
            });

            var offermodel = {
                "OfferHeaderKey": this.offerService.offerHeaderKey,
                "VersionNo": this.offerService.versionNo
            }
            this.apiService.post("Api/QuoteAPI/OfferExternalCode/", offermodel).subscribe((res: any) => {
                this.offerexternalcde = res.ExternalCode;
                this.status = res.Status;
            });
        }
        else
        {
            model = {
                "ProductCode": this.offerService.productCode,
                "ProcessCode": this.offerService.processCode,
                "DepartmentCode": this.offerService.departmentCode,
                "ClientKey": this.offerService.clientCode
            };

            this.apiService.post("Api/QuoteTemplateAPI/LoadOffer/", model).subscribe((res: any) => {

                for (var stepCode in res.Steps) {
                    for (var groupCode in res.Steps[stepCode].ControlGroups) {
                        for (var controlCode in res.Steps[stepCode].ControlGroups[groupCode].Controls) {
                            if (res.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['QuoteSummary'].Value) {
                                this.isSummary = true;
                                break;
                            }
                            if (res.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['OnLoad'].Value) {
                                this.templateService.executeScript(res.Referentials, res.Steps,
                                    res.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode], "OnLoad", res.Variables, null, null, null);
                            }
                        }
                    }
                }

                this.wizard = res;
                this.referentials = res.Referentials;
                this.wizard.ProgressCount = 0;
                this.decimals = "1." + res.CurrencyDecimals + "-" + res.CurrencyDecimals + "";
                this.updateStepOfferDocumentCodes(); // update the **codes property
  //              this.populateDDControls(); //to populated the dropdown control values
                //this.executeScript(); //Onload script execution

            });
        }

    }

    updateStepOfferDocumentCodes() {

        this.stepCodes = [];
        this.offerCodes = [];
        this.documentCodes = [];
        for (var stepKey in this.wizard.Steps) {
            this.stepCodes.push(stepKey);
            if (this.wizard.Steps[stepKey].Type == 'Offer') {
                for (var offerKey in this.wizard.Steps[stepKey].Offers)
                    this.offerCodes.push(offerKey);
            }
        }

        //update documentCodes
        if (this.wizard.Documents) {
            for (var docKey in this.wizard.Documents)
                if (this.wizard.Documents[docKey].IsSelected == true)
                    this.documentCodes.push(docKey);
        }

        if (this.wizard.IsQuoteSaved) {
            var stepcode = +this.wizard.Steps[stepKey].Code;
            this.defaultStep = stepcode - 1;
            this.offerService.currentStep = this.defaultStep + 1;
            this.offerService.clientCode = this.wizard.ClientKey;
        }
        else {
            this.defaultStep = 1;
            this.offerService.currentStep = 2;
            this.wizard.ClientKey = this.offerService.clientCode;
        }
        this.wizard.ClientKey = this.offerService.clientCode;
        this.wizard.ErrorFound = false;
        this.loadClient();
    }

    loadClient() {
        var model = {
            "ProductCode": "",
            "ProcessCode": this.offerService.clientNewOffer, //434 DMISR //396 TLTI
            "DepartmentCode": "",
            "ClientKey": this.offerService.clientCode
        };

        if (!this.wizard.IsCommonClient || this.wizard.Steps[1].GroupCodes.length == 0) {
            this.apiService.post("Api/ClientApi/SyncWizard/", model).subscribe((clientResult: any) => {

                for (var stepCode in clientResult.Steps) {
                    for (var groupCode in clientResult.Steps[stepCode].ControlGroups) {
                        for (var controlCode in clientResult.Steps[stepCode].ControlGroups[groupCode].Controls) {
                            if (clientResult.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['QuoteSummary'].Value) {
                                this.isSummary = true;
                                break;
                            }
                            if (clientResult.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode].Properties['OnLoad'].Value) {
                                this.templateService.executeScript(clientResult.Referentials, clientResult.Steps,
                                    clientResult.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode], "OnLoad", clientResult.Variables, null, null, null);
                            }
                        }
                    }
                }

                this.clientWizard = clientResult;
                this.mergeClientTemplate(this.clientWizard); //To copy the client template to the step 1 of Offer template


            });
        } else {
            this.isSummary = true;
            //this.getInsuredPolicyTerm();
        }
    }

    //Make predefined client wizard as part of Offer wizard step 1
    mergeClientTemplate(clientWizard) {

        for (var stepKey in this.wizard.Steps) {
            this.wizard.Steps[stepKey] = _.cloneDeep(clientWizard.Steps[stepKey]);
            for (var refKey in clientWizard.Referentials) {
                if (!this.wizard.Referentials[refKey])
                    this.wizard.Referentials[refKey] = _.cloneDeep(clientWizard.Referentials[refKey]);
            }
            break;
        }
    }

    //To populate dropdown controls
    populateDDControls() {
        for (var stepCode in this.wizard.Steps) {
            for (var groupCode in this.wizard.Steps[stepCode].ControlGroups) {
                for (var controlCode in this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls) {

                    this.control = this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode];
                    if (this.control.Referential && this.control.Referential != "") {
                        this.control.Items = this.filterDropDownData(this.control);
                        this.getDependencyReferentials();
                    }
                }
            }
        }

    }

    getDependencyReferentials() {
        if (this.control.FieldType == "Lookup" &&
            this.referentials[this.control.Referential] &&
            this.referentials[this.control.Referential].IsDependency) {

            var controls = {};
            for (var stepKey in this.wizard.Steps) {
                for (var controlKey in this.wizard.Steps[stepKey].Controls) {
                    controls[controlKey] = this.wizard.Steps[stepKey].Controls[controlKey];
                }

                for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        controls[controlKey] = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey];
                    }
                }
            }

            var dependency = { "Code": this.control.Referential, "Value": this.control.Value, Module: "CLIENT" };

            this.apiService.post("Api/TemplateApi/DependencyRef/", dependency).subscribe((res: any) => {
                var dependencies = [];
                for (var refrentialKey in res) {
                    if (this.referentials[refrentialKey]) {
                        this.referentials[refrentialKey].Values = _.cloneDeep(res[refrentialKey].Values);
                        dependencies.push(refrentialKey);
                    }
                }

                //although its not efficient but it seems we have to rebind the dropdown
                for (var stepKey in this.wizard.Steps) {
                    for (var controlKey in this.wizard.Steps[stepKey].Controls) {
                        if (this.wizard.Steps[stepKey].Controls[controlKey].Referential &&
                            dependencies.indexOf(this.wizard.Steps[stepKey].Controls[controlKey].Referential) >= 0) {
                            this.wizard.Steps[stepKey].Controls[controlKey].Items =
                                this.filterDropDownData(this.wizard.Steps[stepKey].Controls[controlKey]);
                        }
                    }

                    for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                        for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                            if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Referential &&
                                dependencies.indexOf(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Referential) >= 0) {
                                this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Items =
                                    this.filterDropDownData(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey]);
                            }
                        }
                    }
                }

            });
        }
    }

    filterDropDownData(control) {
        var selectedItems = [];
        this.loadingDDLdata = true;
        if (control.Referential &&
            control.Properties['FilterData'] &&
            control.Properties['FilterData'].Values &&
            control.Properties['FilterData'].Values.length > 0 &&
            this.referentials[control.Referential] &&
            this.referentials[control.Referential].Values) {
            for (var i = 0; i < control.Properties['FilterData'].Values.length; i++) {
                var key = control.Properties['FilterData'].Values[i];
                selectedItems.push({ "Key": key, "Value": this.referentials[control.Referential].Values[key] });
            }
        }
        else if (control.Referential &&
            this.referentials[control.Referential] &&
            this.referentials[control.Referential].Values) {
            for (var refKey in this.referentials[control.Referential].Values)
                selectedItems.push({ "Key": refKey, "Value": this.referentials[control.Referential].Values[refKey] });
        }
        else
            selectedItems = [];
        if (control.Value && !selectedItems.find(item => item.Key == control.Value))
            control.Value = "";
        this.loadingDDLdata = false;
        return selectedItems;
    }


    executeScript() {

        for (var stepCode in this.wizard.Steps) {
            //For controls under step 1 [Standard step (Used for client Details)]
            if (this.wizard.Steps[stepCode].Type == 'Standard') {
                for (var groupCode in this.wizard.Steps[stepCode].ControlGroups) {
                    for (var controlCode in this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls) {
                        this.control = this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode];
                        if (this.control.Properties['OnLoad'].Value) {
                            this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, null);
                            this.referentials = this.wizard.Referentials;
                            this.getDependencyReferentials();
                        }
                    }
                }
            }
            //For controls under step 2 [Dynamic step (product details)]
            else if (this.wizard.Steps[stepCode].Type == 'Dynamic') {
                
                //execute all onload scripts for controls within root ControlGroups
                for (var groupCode in this.wizard.Steps[stepCode].ControlGroups) {
                    for (var controlCode in this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls) {
                        this.control = this.wizard.Steps[stepCode].ControlGroups[groupCode].Controls[controlCode];
                        if (this.control.Properties['OnLoad'].Value) {
                            this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, null);
                            this.referentials = this.wizard.Referentials;
                            this.getDependencyReferentials();
                        }
                    }
                }
                //execute all onload scripts for controls within all Section ControlGroups
                this.sections = this.wizard.Steps[stepCode].Sections;
                for (var sectionCode in this.sections) {
                    //Controls under sections
                    for (var groupCode in this.sections[sectionCode].ControlGroups) {
                        for (var controlCode in this.sections[sectionCode].ControlGroups[groupCode].Controls) {
                            this.control = this.sections[sectionCode].ControlGroups[groupCode].Controls[controlCode];
                            if (this.control.Properties['OnLoad'].Value) {
                                this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, null);
                                this.referentials = this.wizard.Referentials;
                                this.getDependencyReferentials();
                            }
                        }
                    }

                    //controls under sections\covers
                    this.covers = this.wizard.Steps[stepCode].Sections[sectionCode].Covers;
                    for (var coverCode in this.covers) {
                        for (var groupCode in this.covers[coverCode].ControlGroups) {
                            for (var controlCode in this.covers[coverCode].ControlGroups[groupCode].Controls) {
                                this.control = this.covers[coverCode].ControlGroups[groupCode].Controls[controlCode];
                                if (this.control.Properties['OnLoad'].Value) {
                                    this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, null);
                                    this.referentials = this.wizard.Referentials;
                                    this.getDependencyReferentials();
                                }
                            }
                        }
                    }
                }

            } //For controls under step 3 [Offer step (Offer details)]
            else if (this.wizard.Steps[stepCode].Type == 'Offer') {
                //execute all onload scripts for controls within offer Controls
                this.offers = this.wizard.Steps[stepCode].Offers;
                for (var offerCode in this.offers) {
                    //Offer Controls
                    for (var controlCode in this.offers[offerCode].Controls) {
                        this.control = this.offers[offerCode].Controls[controlCode];
                        if (this.control.Properties['OnLoad'].Value) {
                            this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, offerCode);
                            this.referentials = this.wizard.Referentials;
                            this.getDependencyReferentials();
                        }
                    }
                    //section Controls
                    this.sections = this.offers[offerCode].Sections;
                    for (var sectionCode in this.sections) {
                        for (var controlCode in this.sections[sectionCode].Controls) {
                            this.control = this.sections[sectionCode].Controls[controlCode];
                            if (this.control.Properties['OnLoad'].Value) {
                                this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, offerCode);
                                this.referentials = this.wizard.Referentials;
                                this.getDependencyReferentials();
                            }

                        }

                        //Cover Controls
                        this.covers = this.offers[offerCode].Sections[sectionCode].Covers;
                        for (var coverCode in this.covers) {
                            for (var controlCode in this.covers[coverCode].Controls) {
                                this.control = this.covers[coverCode].Controls[controlCode];
                                if (this.control.Properties['OnLoad'].Value) {
                                    this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnLoad", this.wizard.Variables, null, null, offerCode);
                                    this.referentials = this.wizard.Referentials;
                                    this.getDependencyReferentials();
                                }

                            }
                        }
                    }
                }
            }
        }
    }

    addOffer(stepCode, offerCode) {
        var key = 0;
        for (var offerKey in this.wizard.Steps[stepCode].Offers) {
            if (parseInt(offerKey) > key)
                key = parseInt(offerKey);
        }

        key = key + 1;
        this.wizard.Steps[stepCode].Offers[key.toString()] = _.cloneDeep(this.wizard.Steps[stepCode].Offers[offerCode]);
        this.wizard.Steps[stepCode].Offers[key.toString()].Code = key.toString();

        this.offerCodes = [];
        for (var offerkey in this.wizard.Steps[stepCode].Offers) this.offerCodes.push(offerkey);
    }

    deleteOffer(stepCode, offerCode) {
        var count = 0;
        for (var offerKey in this.wizard.Steps[stepCode].Offers) count = count + 1;

        if (count > 1) {
            delete this.wizard.Steps[stepCode].Offers[offerCode];

            this.offerCodes = [];
            for (var offerkey in this.wizard.Steps[stepCode].Offers) this.offerCodes.push(offerkey);
        }
        else
            this.toastrService.error(this.translate.instant("Cannot delete all offers"));
    }

    enterWizardStep(ev) {
        if (this.wizardComponent && this.wizardComponent.currentStep) {
            var nextStep = parseInt(this.wizardComponent.currentStep.stepId)
            var lastStep = parseInt(this.offerService.currentStep);
            if (nextStep !== lastStep) {
                //navigation using step indecator
                if (nextStep < lastStep) {
                    //backward navigation
                    this.previousStep(this.wizardComponent.currentStep.stepId);
                } else if (nextStep > lastStep) {
                    //forward navigation
                    this.nextStep(this.wizard, this.wizardComponent.currentStep.stepId)
                }
            }
        }
    }

    
    nextStep(wizard, stepKey) {

        if (this.wizard.Steps[stepKey].Scripts &&
            this.wizard.Steps[stepKey].Scripts["OnNext"]) {
           var result = this.templateService.executeGlobalScript(this.wizard.Referentials,
               this.wizard.Steps, null, this.wizard.Variables, null, this.wizard.Steps[stepKey].Scripts["OnNext"]);
            if (typeof result !== 'undefined' && !result) return;
        }

        this.wizard = wizard;
        this.offerService.wizard = wizard;
        if (!this.offerService.currentStep || this.offerService.currentStep != stepKey)
            this.offerService.currentStep = stepKey;

        if (this.wizard.IsView) {
            var nextStepID = parseInt(this.offerService.currentStep) + 1;
            this.setStep(nextStepID);
            this.offerService.currentStep = nextStepID;
            this.wizardComponent.goToNextStep();
            return;
        }

        this.nextStepID = parseInt(this.offerService.currentStep) + 1;

        this.offerService.errorControls = [];
        this.offerService.scriptErrorControls = [];
        var step = this.wizard.Steps[this.offerService.currentStep];


        //standard controls
        this.offerService.validateControls(this.wizard.Steps[stepKey].Controls); 
        //Group Controls
        for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) { 
            var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
            this.offerService.validateControls(controls);
        }

        //Section Controls
        var sections = this.wizard.Steps[stepKey].Sections;
        for (var sectionKey in sections) {
            //Section standard controls
            this.offerService.validateControls(sections[sectionKey].Controls);
            //Section Group Controls
            for (var groupKey in sections[sectionKey].ControlGroups) {
                var controls = sections[sectionKey].ControlGroups[groupKey].Controls;
                this.offerService.validateControls(controls);
            }

            //Cover Controls within Sections
            var covers = this.wizard.Steps[stepKey].Sections[sectionKey].Covers;

            for (var coverKey in covers) {
                //Cover standard controls
                this.offerService.validateControls(covers[coverKey].Controls);
                //Cover Group Controls
                for (var groupKey in covers[coverKey].ControlGroups) {
                    var controls = covers[coverKey].ControlGroups[groupKey].Controls;
                    this.offerService.validateControls(controls);
                }
            }
        }

        this.requiredControls = this.offerService.errorControls;

        if (this.requiredControls.length > 0) 
            this.toastrService.error(this.translate.instant("Provide details for all required fields"));
            
        
        else if (this.offerService.scriptErrorControls.length > 0) 
            this.toastrService.error(this.translate.instant("Please correct the validation errors to proceed."));
        
        else if (this.wizard.Steps[stepKey].Type == "Standard") {
            this.apiService.post("Api/ClientApi/Update/", this.clientWizard).subscribe((clientResult: any) => {
                this.offerService.currentStep = this.nextStepID;
                this.setStep(this.nextStepID);
                this.wizardComponent.goToNextStep();
            });
        }
        else {

            this.setStep(this.nextStepID);
            this.offerService.currentStep = this.nextStepID;
            this.refreshItemCoverFields();
            if (!this.wizard.IsQuoteSaved)
                this.calculatePremium(this.wizard);

            this.wizardComponent.goToNextStep();
        }
    }
    
    refreshItemCoverFields() {
        var controlValues = {};
        var referentialKeys = {};
        var sectionVisibility = [];

        for (var stepKey in this.wizard.Steps) {
            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    controlValues[controlKey] = controls[controlKey].Value;
                    if (controls[controlKey].Referential)
                        referentialKeys[controlKey] = controls[controlKey].Referential;
                }


                var sections = this.wizard.Steps[stepKey].Sections;
                for (var sectionKey in sections) {
                    for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                        var controls = sections[sectionKey].ControlGroups[groupKey].Controls;
                        sectionVisibility[sectionKey] = sections[sectionKey].Visible; //storing section visibility
                        for (var controlKey in controls) {
                            controlValues[sectionKey + "_" + controlKey] = controls[controlKey].Value;
                            if (controls[controlKey].Referential)
                                referentialKeys[sectionKey + "_" + controlKey] = controls[controlKey].Referential;
                        }
                        var covers = sections[sectionKey].Covers;
                        for (var coverKey in covers) {
                            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                                var controls = covers[coverKey].ControlGroups[groupKey].Controls;
                                for (var controlKey in controls) {
                                    controlValues[sectionKey + "_" + coverKey + "_" + controlKey] = controls[controlKey].Value;
                                    if (controls[controlKey].Referential)
                                        referentialKeys[sectionKey + "_" + coverKey + "_" + controlKey] = controls[controlKey].Referential;
                                }
                            }
                        }
                    }
                }
            }
        }
        var offers = this.wizard.Step.Offers;
        for (var offerKey in offers) {

            var controls = offers[offerKey].Controls;
            for (var controlKey in controls) {
                if (!(controlValues[controlKey] == undefined))
                    controls[controlKey].Value = controlValues[controlKey];
                if (referentialKeys[controlKey])
                    controls[controlKey].Referential = referentialKeys[controlKey];
            }

            var sections = offers[offerKey].Sections;
            for (var sectionKey in sections) {
                sections[sectionKey].Visible = sectionVisibility[sectionKey];//reseting section visibility
                var controls = sections[sectionKey].Controls;
                for (var controlKey in controls) {
                    if (!(controlValues[sectionKey + "_" + controlKey] == undefined))
                        controls[controlKey].Value = controlValues[sectionKey + "_" + controlKey];
                    if (referentialKeys[sectionKey + "_" + controlKey])
                        controls[controlKey].Referential = referentialKeys[sectionKey + "_" + controlKey];
                }
                var covers = sections[sectionKey].Covers;
                for (var coverKey in covers) {

                    // Initialization marked as required
                    covers[coverKey].Initialise = 1;
                    var controls = covers[coverKey].Controls;
                    for (var controlKey in controls) {
                        if (referentialKeys[sectionKey + "_" + coverKey + "_" + controlKey])
                            if (!controls[controlKey].Referential)
                                controls[controlKey].Referential = referentialKeys[sectionKey + "_" + coverKey + "_" + controlKey];
                        if (!(controlValues[sectionKey + "_" + coverKey + "_" + controlKey] == undefined)) {
                            //if (!controls[controlKey].Value) //ISSUE 1744 : DDL value in offer step not changing even if we change item DDL value
                            controls[controlKey].Value = controlValues[sectionKey + "_" + coverKey + "_" + controlKey];
                        }

                        //control intial value: following logic replaced by OverrideInitalValue
                        //if (controls[controlKey].Initialise == null || controls[controlKey].Initialise == undefined)
                        //  controls[controlKey].Initialise = (controls[controlKey].Value != null);
                    }
                }
            }
        }
}
    
    previousStep(stepID) {

        if (this.wizard.Steps[stepID].Scripts &&
            this.wizard.Steps[stepID].Scripts["OnPrevious"]) {
            var result = this.templateService.executeGlobalScript(this.wizard.Referentials,
                this.wizard.Steps, null, this.wizard.Variables, null, this.wizard.Steps[stepID].Scripts["OnPrevious"]);
            if (typeof result !== 'undefined' && !result) return;
        }

        var step = this.wizard.Steps[stepID];
        var prevStepID = parseInt(stepID) - 1;
        this.setStep(prevStepID);
        this.wizardComponent.goToPreviousStep();
    }

    //To set the step at the wizard root
    setStep(stepID) {
        var step = this.wizard.Steps[stepID];
        if (this.offerService.lastValidatedStep < this.offerService.currentStep)
            this.offerService.lastValidatedStep = this.offerService.currentStep

        this.offerService.currentStep = stepID;
        this.wizard.Step = step;
        if (!this.wizard.Step.Code)
            this.wizard.Step.Code = stepID;
       }
   
    //Calculate premium for slected offer or all offers
    calculatePremium(wizard, selectedOffer = "") {
        this.wizard = wizard;
        this.resetCalculatedValues(selectedOffer);
        this.offers = this.wizard.Step.Offers;

        if (this.offers) {

            //get standard control values from all steps
            var standardControls = {};
            for (var stepKey in this.wizard.Steps) {
                //get standard controls from Offer step (step 3) because this step does not follow the GroupCodes and ControlGroups template structure
                if (this.wizard.Steps[stepKey].Type == "Offer") {
                    var controls = this.wizard.Steps[stepKey].Controls;
                    for (var controlKey in controls) {
                        if (controls[controlKey].Value && controls[controlKey].Value.Code)
                            standardControls[controlKey] =
                                {
                                    "Value": controls[controlKey].Value.Code,
                                    "Properties": controls[controlKey].Properties,
                                    "FieldType": controls[controlKey].FieldType
                                };
                        else
                            standardControls[controlKey] =
                                {
                                    "Value": controls[controlKey].Value,
                                    "Properties": controls[controlKey].Properties,
                                    "FieldType": controls[controlKey].FieldType
                                };
                    }
                }
                else {

                    //get standard controls from Standard and Dynamic steps (step 1 and 2) because these steps follow the GroupCodes and ControlGroups template structure
                    var controlGroups = this.wizard.Steps[stepKey].ControlGroups;
                    for (var groupKey in controlGroups) {
                        for (var controlKey in controlGroups[groupKey].Controls) {
                            if (controlGroups[groupKey].Controls[controlKey].Value && controlGroups[groupKey].Controls[controlKey].Value.Code)

                                standardControls[controlKey] =
                                    {
                                    "Value": controlGroups[groupKey].Controls[controlKey].Value.Code,
                                    "Properties": controlGroups[groupKey].Controls[controlKey].Properties,
                                    "FieldType": controlGroups[groupKey].Controls[controlKey].FieldType,
                                    "GroupCode": groupKey,
                                    "StepCode": stepKey
                                    };
                            else
                                standardControls[controlKey] =
                                    {
                                    "Value": controlGroups[groupKey].Controls[controlKey].Value,
                                    "KeyValue": controlGroups[groupKey].Controls[controlKey].KeyValue,
                                    "Properties": controlGroups[groupKey].Controls[controlKey].Properties,
                                    "FieldType": controlGroups[groupKey].Controls[controlKey].FieldType,
                                    "GroupCode": groupKey,
                                    "StepCode": stepKey
                                    };
                        }
                    }
                }
            }

            this.spinner.show();
            var offerCalcCount = 0;
            //Operations for each offer in Offer Step
            for (var offerKey in this.offers) {

                if (selectedOffer != "" && offerKey != selectedOffer) continue;
                if (!this.offers[offerKey].Visible) continue;

                //document.getElementById("offer" + offerKey).classList.add('loader-box');
                //document.getElementById("offer" + offerKey).classList.add('loader');
                

                var model = {
                    "Key": offerKey,
                    "Code": this.offers[offerKey].Code,
                    "Controls": standardControls,
                    "Sections": {},
                    "ProductCode": this.wizard.ProductCode,
                    "ClientKey": this.wizard.ClientKey,
                    "CalculationMode": this.wizard.CalculationMode,
                    "ProcessCode": this.wizard.ProcessCode,
                    "PolicyKey": "",
                    "DepartmentCode": this.wizard.DepartmentCode,
                    "SystemIndicator": "",
                    "Variables":""
                };

                //get standard control values from offer step
                var controls = this.offers[offerKey].Controls;
                 for (var controlKey in controls) {
                    if (controls[controlKey].Value && controls[controlKey].Value.Code)
                        standardControls[controlKey] =
                            {
                                "Value": controls[controlKey].Value.Code,
                                "Properties": controls[controlKey].Properties,
                                "FieldType": controls[controlKey].FieldType
                            };
                    else
                        standardControls[controlKey] =
                            {
                                "Value": controls[controlKey].Value,
                                "Properties": controls[controlKey].Properties,
                                "FieldType": controls[controlKey].FieldType
                            };
                }

                //if not a single cover selected then no need to execute the section script
                var validSections = {};
                for (var sectionKey in this.offers[offerKey].Sections) {
                    if (!this.offers[offerKey].Sections[sectionKey].Visible) continue; //if section is hidden
                    for (var coverKey in this.offers[offerKey].Sections[sectionKey].Covers) {
                        var cover = this.offers[offerKey].Sections[sectionKey].Covers[coverKey];
                        if (cover.Selection == true ||
                            cover.Selection == 'Mandatory' ||
                            cover.Selection == 'Conditional') {
                            if (!validSections[sectionKey]) validSections[sectionKey] = true;
                        }
                    }
                }

                //Get item control values for offer step
                for (var sectionKey in this.offers[offerKey].Sections) {
                    if (!validSections[sectionKey]) continue;
                    if (!model.Sections[sectionKey])
                        model.Sections[sectionKey] = { "Controls": {}, "CoverCodes": this.offers[offerKey].Sections[sectionKey].CoverCodes };

                    //Get section control values for all step
                    for (var stepKey in this.wizard.Steps) {
                        if (!this.wizard.Steps[stepKey].Sections[sectionKey]) continue;
                        var section = this.wizard.Steps[stepKey].Sections[sectionKey];

                        for (var controlGroupKey in section.ControlGroups) {
                            var controls = section.ControlGroups[controlGroupKey].Controls;
                            for (controlKey in controls) {
                                if (controls[controlKey].Value && controls[controlKey].Value.Code)
                                    model.Sections[sectionKey].Controls[controlKey] =
                                        { "Value": controls[controlKey].Value.Code, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                                else
                                    model.Sections[sectionKey].Controls[controlKey] =
                                        { "Value": controls[controlKey].Value, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                            }
                        }
                    }

                    //override section control values from offer step
                    var section = this.offers[offerKey].Sections[sectionKey];
                    var controls = section.Controls
                    for (var controlKey in controls) {
                        var hasProps = false;
                        for (var prop in controls[controlKey].Properties) {
                            hasProps = true;
                            break;
                        }

                        if (hasProps) {
                            if (controls[controlKey].Value && controls[controlKey].Value.Code)
                                model.Sections[sectionKey].Controls[controlKey] =
                                    { "Value": controls[controlKey].Value.Code, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                            else
                                model.Sections[sectionKey].Controls[controlKey] =
                                    { "Value": controls[controlKey].Value, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                        }
                        else {
                            if (model.Sections[sectionKey].Controls[controlKey]) {
                                if (controls[controlKey].Value && controls[controlKey].Value.Code)
                                    model.Sections[sectionKey].Controls[controlKey].Value = controls[controlKey].Value && controls[controlKey].Value.Code;
                                else
                                    model.Sections[sectionKey].Controls[controlKey].Value = controls[controlKey].Value && controls[controlKey].Value;
                            }
                        }

                    }
                }


                //get cover control values for all step
                for (var sectionKey in this.offers[offerKey].Sections) {
                    if (!validSections[sectionKey]) continue;
                    for (var coverKey in this.offers[offerKey].Sections[sectionKey].Covers) {

                        var cover = this.offers[offerKey].Sections[sectionKey].Covers[coverKey];

                        if ((cover.Selection == 'Mandatory' && cover.Selected == false) ||
                            (cover.Selection == 'Conditional' && cover.Selected == false))
                            cover.Selected = true;
                        else if (cover.Selection == 'Excluded')
                            continue;
                        /*else if (cover.Selection == 'Excluded' ||
                            cover.IsFree == true)
                            continue;
                        */ //commented off as free cover controls are not populated with default data during transformation. all controls are empty.
                        if (!model.Sections[sectionKey].Covers)
                            model.Sections[sectionKey].Covers = {};

                        if (!model.Sections[sectionKey].Covers[coverKey])
                            model.Sections[sectionKey].Covers[coverKey] =
                                { "Controls": {}, "Selected": cover.Selected, "Mandatory": cover.Mandatory };

                        model.Sections[sectionKey].Covers[coverKey].Initialise = cover.Initialise;

                        //get cover control values for all steps
                        this.steps = this.wizard.Steps;
                        for (var stepKey in this.steps) {
                            if (!this.steps[stepKey].Sections[sectionKey]) continue;
                            if (!this.steps[stepKey].Sections[sectionKey].Covers[coverKey]) continue;
                            var cover = this.steps[stepKey].Sections[sectionKey].Covers[coverKey];

                            for (var controlGroupKey in cover.ControlGroups) {
                                var controls = cover.ControlGroups[controlGroupKey].Controls;
                                for (controlKey in controls) {
                                    if (controls[controlKey].Value && controls[controlKey].Value.Code)
                                        model.Sections[sectionKey].Covers[coverKey].Controls[controlKey] =
                                            { "Value": controls[controlKey].Value.Code, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                                    else
                                        model.Sections[sectionKey].Covers[coverKey].Controls[controlKey] =
                                            { "Value": controls[controlKey].Value, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                                }
                            }
                        }

                        //override cover control values for offer step
                        var cover = this.offers[offerKey].Sections[sectionKey].Covers[coverKey];
                        var controls = cover.Controls
                        for (controlKey in controls) {
                            if (controls[controlKey].Value && controls[controlKey].Value.Code)
                                model.Sections[sectionKey].Covers[coverKey].Controls[controlKey] =
                                    { "Value": controls[controlKey].Value.Code, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                            else
                                model.Sections[sectionKey].Covers[coverKey].Controls[controlKey] =
                                    { "Value": controls[controlKey].Value, "Properties": controls[controlKey].Properties, "FieldType": controls[controlKey].FieldType };
                            //following logic replaced by OverrideInitalValue
                            //model.Sections[sectionKey].Covers[coverKey].Controls[controlKey].Initialise = controls[controlKey].Initialise;
                        }
                    }
                }

                this.wizard.ProgressCount = this.wizard.ProgressCount + 1;

                model.ProductCode = this.wizard.ProductCode;
                model.ClientKey = this.wizard.ClientKey;
                model.CalculationMode = this.wizard.CalculationMode;
                model.ProcessCode = this.wizard.ProcessCode;
                model.PolicyKey = this.wizard.PolicyKey;
                model.DepartmentCode = this.wizard.DepartmentCode;
                model.SystemIndicator = this.wizard.SystemIndicator;
                model.Variables = this.wizard.Variables;

                offerCalcCount = offerCalcCount + 1;
                this.apiService.post("Api/QuoteApi/Calculate/", model).subscribe((res: any) => {

                    if (res.Message) { // calculation falied
                        if (this.wizard.ProgressCount > 0)
                            this.wizard.ProgressCount = this.wizard.ProgressCount - 1;
                        if (res.Key) {
                            //$('#offer' + res.data.Key).children('.ibox-content').removeClass("sk-loading");
                           // document.getElementById("offer" + offerKey).classList.remove('loader-box');
                            //document.getElementById("offer" + offerKey).classList.remove('loader');
                            this.spinner.hide();

                            for (var offerKey in this.offers) {
                                if (res.Key === offerKey) {
                                    this.offers[offerKey].Error = res.Message;
                                    break;
                                }
                            }

                            if (this.wizard.Scripts) {
                                for (var scriptKey in this.wizard.Scripts) {
                                    if (this.wizard.Scripts[scriptKey].IsCalculationError) {
                                        this.templateService.executeGlobalScript(this.wizard.Referentials, 
                                        this.wizard.Steps, offerKey, res.data.Variables, pageError, this.wizard.Scripts[scriptKey].Value);
                                    }
                                }
                            }
                        }
                    }
                    else {   //success
                        this.wizard.Variables = res.Variables;
                        if (this.wizard.ProgressCount > 0)
                            this.wizard.ProgressCount = this.wizard.ProgressCount - 1;

                        for (var stepKey in this.wizard.Steps) {
                            if (this.wizard.Steps[stepKey].Type != 'Offer') continue;
                            for (var offerKey in this.wizard.Steps[stepKey].Offers) {
                                if (res.Key == offerKey) {
                                    if (res.PolicyKey && this.wizard.PolicyKey != res.PolicyKey)
                                        this.wizard.PolicyKey = res.PolicyKey;

                                    
                                    //$('#offer' + offerKey).children('.ibox-content').removeClass("sk-loading");
                                   // document.getElementById("offer" + offerKey).classList.remove('loader-box');
                                   // document.getElementById("offer" + offerKey).classList.remove('loader');
                                    this.spinner.hide();

                                    var errorFound = false;
                                    for (var sectionKey in this.wizard.Steps[stepKey].Offers[offerKey].Sections) {
                                        if (!res.Sections[sectionKey]) continue;
                                        var section = this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey];

                                        section.Errors = res.Sections[sectionKey].Errors;
                                        if (section.Errors && section.Errors.length > 0) {
                                            if (res.Sections[sectionKey].ErrorCount > 0)
                                                errorFound = true;
                                            if (this.wizard.IsGroup == true) {
                                                for (var coverGroupKey in this.wizard.CoverGroups) {
                                                    var groupCode = this.wizard.CoverGroups[coverGroupKey].GroupCode;
                                                    var sectionCode = this.wizard.CoverGroups[coverGroupKey].SectionCode;
                                                    if (groupCode && sectionCode == sectionKey && !this.wizard.Groups[groupCode].Errors) {
                                                        this.wizard.Groups[groupCode].Errors = section.Errors;
                                                    }
                                                }
                                            }
                                        }

                                        //transfere product generator item control values
                                        for (var controlKey in res.Sections[sectionKey].Controls) {
                                            var refKey = sectionKey + "_" + controlKey;

                                            if (section.Controls[controlKey]) {
                                                section.Controls[controlKey].OldValue = section.Controls[controlKey].Value = res.Sections[sectionKey].Controls[controlKey].Value;

                                                if (section.Controls[controlKey].FieldType == "DateTime" && section.Controls[controlKey].Value) {
                                                    var dateParts = [];
                                                    dateParts = section.Controls[controlKey].Value.split('/');
                                                    if (dateParts.length > 1) {
                                                        section.Controls[controlKey].DateValue = { "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) };
                                                    }
                                                    else {
                                                        dateParts = section.Controls[controlKey].Value.split('-');
                                                        section.Controls[controlKey].DateValue = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
                                                    }
                                                }

                                            }
                                            else {
                                                //control not added on screen but used in product generator
                                                section.Controls[controlKey] = {
                                                    "FieldType": res.Sections[sectionKey].Controls[controlKey].FieldType,
                                                    "Value": res.Sections[sectionKey].Controls[controlKey].Value
                                                };
                                            }
                                            //Uncomment temp test
                                            
                                            if (res.Referentials[refKey] &&
                                                this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey].Controls[controlKey].Properties.DisbaleProductScript &&
                                                !this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey].Properties.DisbaleProductScript.Value &&
                                                controls[controlKey].ListItemsChange)
                                            {
                                                this.referentials[refKey] = { "Values": _.cloneDeep(res.Referentials[refKey].Values), "Code": refKey };
                                                this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Controls[controlKey].Referential = refKey;
                                            }
                                            
                                        }

                                        for (var coverKey in this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Covers) {
                                            var cover = this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Covers[coverKey];

                                            if (cover.Selection == 'Excluded') continue;
                                            if (!res.Sections[sectionKey]) continue;
                                            if (!res.Sections[sectionKey].Covers[coverKey]) continue;

                                            cover.Value = res.Sections[sectionKey].Covers[coverKey].Value;
                                            cover.Errors = res.Sections[sectionKey].Covers[coverKey].Errors;

                                            //if conditioanl cover and zero premium then unselect the cover if its selected
                                            if (cover.Selection == 'Conditional' &&
                                                res.Sections[sectionKey].Covers[coverKey].IsValidCover == 0 &&
                                                cover.Selected == true &&
                                                (!cover.Errors || (cover.Errors && cover.Errors.length == 0))) {
                                                cover.Selected = false;

                                                //cover selection changed so execute if there is any client script
                                                if (cover.Scripts && cover.Scripts['OnChange'] && cover.Scripts['OnChange'].IsChange) {
                                                    if (!cover.Text && cover.Code) cover.Text = this.wizard.Covers[cover.Code].Text;
                                                    this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnChange", this.wizard.Variables, cover.Scripts, cover, offerKey);
                                                }
                                            }

                                            //if not mandatory and there is errors then unselect the cover if its selected
                                            if (cover.Selected == true && cover.Errors && cover.Errors.length > 0) {
                                                if (cover.Selection != 'Mandatory' && cover.Selected == true) {
                                                    cover.Selected = false;

                                                    //cover selection changed so execute if there is any client script
                                                    if (cover.Scripts && cover.Scripts['OnChange'] && cover.Scripts['OnChange'].IsChange) {
                                                        if (!cover.Text && cover.Code) cover.Text = this.wizard.Covers[cover.Code].Text;
                                                        this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnChange", this.wizard.Variables, cover.Scripts, cover, offerKey);
                                                    }
                                                }
                                                errorFound = true;
                                            }

                                            if (cover.Initialise == 1 && (!cover.Errors || (cover.Errors && cover.Errors.length == 0))) {
                                                cover.Initialise = 0;
                                            }

                                            //we might have premium value returned but since if the cover is not valid then need to reset premium
                                            if (cover.Selected == true && res.Sections[sectionKey].Covers[coverKey].Value)
                                                cover.Value = res.Sections[sectionKey].Covers[coverKey].Value;
                                            else
                                                cover.Value = 0;

                                            //we might have premium value returned but since if the cover is not valid then need to reset premium
                                            if (cover.Selected == true && res.Sections[sectionKey].Covers[coverKey].DiscountedValue)
                                                cover.DiscountedValue = res.Sections[sectionKey].Covers[coverKey].DiscountedValue;
                                            else
                                                cover.DiscountedValue = cover.Value;

                                            //transfer product genrator cover control values
                                            var controls = res.Sections[sectionKey].Covers[coverKey].Controls;
                                            for (controlKey in controls) {
                                                var refKey = sectionKey + "_" + coverKey + "_" + controlKey;

                                                if (cover.Controls[controlKey]) {
                                                    cover.Controls[controlKey].OldValue =
                                                        cover.Controls[controlKey].Value = controls[controlKey].Value;

                                                    if (cover.Controls[controlKey].FieldType == "DateTime" && cover.Controls[controlKey].Value) {
                                                        var dateParts = [];
                                                        dateParts = cover.Controls[controlKey].Value.split('/');
                                                        if (dateParts.length > 1) {
                                                            cover.Controls[controlKey].DateValue = { "day": parseInt(dateParts[0]), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[2].substring(0, 4)) };
                                                        }
                                                        else {
                                                            dateParts = cover.Controls[controlKey].Value.split('-');
                                                            cover.Controls[controlKey].DateValue = { "day": parseInt(dateParts[2].substring(0, 4)), "month": parseInt(dateParts[1]), "year": parseInt(dateParts[0]) };
                                                        }
                                                    }
                                                }

                                                else {
                                                    //control not added on screen but used in product generator
                                                    cover.Controls[controlKey] =
                                                        { "FieldType": controls[controlKey].FieldType, "Value": controls[controlKey].Value };
                                                }

                                                if (res.Referentials[refKey] &&
                                                    cover.Controls[controlKey].Properties &&
                                                    cover.Controls[controlKey].Properties.DisbaleProductScript &&
                                                    !cover.Controls[controlKey].Properties.DisbaleProductScript.Value &&
                                                    controls[controlKey].ListItemsChange) {
                                                    this.referentials[refKey] = { "Values": _.cloneDeep(res.Referentials[refKey].Values), "Code": refKey };
                                                    cover.Controls[controlKey].Referential = refKey;

                                                    //rebind to ng-select otherwise it wont refresh
                                                    var selectedItems = [];
                                                    for (var itemKey in this.referentials[refKey].Values)
                                                        selectedItems.push({ "Key": itemKey, "Value": this.referentials[refKey].Values[itemKey] });
                                                    cover.Controls[controlKey].Items = selectedItems;
                                                }

                                                //execute calc complete script for cover controls
                                                /*
                                                if (controls[controlKey].Properties["OnCalcComplete"] &&
                                                    controls[controlKey].Properties["OnCalcComplete"].Value) {
                                                    this.templateService.executeScript(this.wizard.Referentials, this.wizard, this.control, "OnCalcComplete", this.wizard.Variables, controls[controlKey].Properties["OnCalcComplete"].Value, cover, offerKey);
                                                }
                                                */
                                            }
                                            cover.Title = cover.Errors && cover.Errors.length > 0 ? cover.Errors[0].Message : this.translate.instant('Premium') + ': ' + this.decimalPipe.transform(cover.Value, this.decimals) + ',' + this.translate.instant('Discounted Premium') + ': ' + this.decimalPipe.transform(cover.DiscountedValue, this.decimals);
                                        }
                                    }

                                    this.wizard.Steps[stepKey].Offers[offerKey].Error = errorFound ? "Error" : "";

                                    this.wizard.Steps[stepKey].Offers[offerKey].Premium = res.Premium;
                                    this.wizard.Steps[stepKey].Offers[offerKey].Tax = res.Tax;
                                    this.wizard.Steps[stepKey].Offers[offerKey].AdminFee = res.AdminFee;
                                    this.wizard.Steps[stepKey].Offers[offerKey].StampFee = res.StampFee;
                                    this.wizard.Steps[stepKey].Offers[offerKey].Value = res.Value;

                                    this.wizard.Steps[stepKey].Offers[offerKey].DiscountedValue = res.DiscountedValue;
                                    this.wizard.Steps[stepKey].Offers[offerKey].DiscountedTax = res.DiscountedTax;
                                    this.wizard.Steps[stepKey].Offers[offerKey].DiscountedPremium = res.DiscountedPremium;
                                    this.wizard.Steps[stepKey].Offers[offerKey].DiscountedAdminFee = res.DiscountedAdminFee;

                                    this.wizard.Steps[stepKey].Offers[offerKey].DiscountedValuePromo = this.decimalPipe.transform((this.wizard.Steps[stepKey].Offers[offerKey].Value - this.wizard.Steps[stepKey].Offers[offerKey].DiscountAmount), this.decimals); 

                                    this.offers = this.wizard.Steps[stepKey].Offers,
                                        this.offers[offerKey].Title = this.translate.instant('Premium') + ' = ' + this.decimalPipe.transform(this.offers[offerKey].Premium, this.decimals) + ', ' + this.translate.instant('Admin Fee') + ': ' + this.decimalPipe.transform(this.offers[offerKey].AdminFee, this.decimals) + ', ' + this.translate.instant('Stamp Fee') + ': ' + this.decimalPipe.transform(this.offers[offerKey].StampFee, this.decimals) + ', ' + this.translate.instant('Tax') + ' = ' + this.decimalPipe.transform(this.offers[offerKey].Tax, this.decimals);
                                    this.offers[offerKey].DiscountedTitle = this.translate.instant('Premium') + ' = ' + this.decimalPipe.transform(this.offers[offerKey].DiscountedPremium, this.decimals) + ', ' + this.translate.instant('Admin Fee') + ': ' + this.decimalPipe.transform(this.offers[offerKey].DiscountedAdminFee, this.decimals) + ', ' + this.translate.instant('Stamp Fee') + ': ' + this.decimalPipe.transform(this.offers[offerKey].StampFee, this.decimals) + ', ' + this.translate.instant('Tax') + ' = ' + this.decimalPipe.transform(this.offers[offerKey].DiscountedTax, this.decimals);

                                    break;
                                }
                            }
                        }

                        var pageError = false;
                        for (var stepKey in this.wizard.Steps) {
                            if (this.wizard.Steps[stepKey].Type != "Offer") continue;
                            for (var offerKey in this.wizard.Steps[stepKey].Offers) {
                                if (this.wizard.Steps[stepKey].Offers[offerKey].Error == 'Error') {
                                    pageError = true;
                                    break;
                                }
                            }
                        }

                        this.wizard.ErrorFound = pageError;

                       
                        if (this.wizard.Scripts) {
                            for (var scriptKey in this.wizard.Scripts) {
                                if (this.wizard.Scripts[scriptKey].IsCalculationComplete) {
                                    //executeScript(referentials, wizardSteps, control, event, offerCode,variables, scripts, cover)
                                    this.templateService.executeGlobalScript(this.wizard.Referentials, this.wizard, offerKey, res.Variables, pageError, this.wizard.Scripts[scriptKey].Value); // TODO
                                }
                            }
                        }

                    }

                });
            }

            if (offerCalcCount == 0)
                this.spinner.hide();
        }
    }


    //reset all figures before calculating offer
    resetCalculatedValues(selectedOfferKey) {
        this.wizard.ErrorFound = true;

        if (this.wizard.Step) {
            this.offers = this.wizard.Step.Offers;
        }
        else {
            for (var stepKey in this.wizard.Steps) {
                if (this.wizard.Steps[stepKey].Type == 'Offer') {
                    this.offers = this.wizard.Steps[stepKey].Offers;
                    this.wizard.Step = this.wizard.Steps[stepKey];
                }
            }
        }

        if (this.wizard.IsGroup) {
            for (var groupKey in this.wizard.Groups)
                this.wizard.Groups[groupKey].Errors = null;
        }

        for (var offerKey in this.offers) {
            if (selectedOfferKey != "" && offerKey != selectedOfferKey) continue;

            var sections = this.offers[offerKey].Sections;
            for (var sectionKey in sections) {
                sections[sectionKey].Errors = null;
                var covers = sections[sectionKey].Covers;
                for (var coverKey in covers) {
                    covers[coverKey].Value = 0;
                    covers[coverKey].DiscountedValue = 0;
                    covers[coverKey].Errors = null;
                }
            }

            this.offers[offerKey].Error = true;
            this.offers[offerKey].Premium = 0;
            this.offers[offerKey].Tax = 0;
            this.offers[offerKey].AdminFee = 0;
            this.offers[offerKey].StampFee = 0;
            this.offers[offerKey].Value = 0;
            this.offers[offerKey].DiscountedValue = 0;
            this.offers[offerKey].DiscountedTax = 0;
            this.offers[offerKey].DiscountedPremium = 0;
            this.offers[offerKey].DiscountedAdminFee = 0;
        }
    }
  
    save() {
        this.apiService.post("Api/QuoteApi/SaveHeader/", this.wizard).subscribe((res: any) => {
            this.apiService.post("Api/QuoteApi/Save/", this.wizard).subscribe((res: any) => {
                this.toastrService.success(this.translate.instant("Quote No. " + res.ExternalCode + " has been saved successfully"));
                this.offerService.offerHeaderKey = res.Key;
                this.offerService.versionNo =  res.versionNo;
                this.offerexternalcde = res.ExternalCode;
                //this.router.navigate(["../"], { relativeTo: this.route });
                if (this.checkCodeSave) {
                    this.checkCode();
                    this.checkCodeSave = false;
                }
            });
        });        
    }
    
    print() {

        this.apiService.post("Api/QuoteApi/Save/", this.wizard).subscribe((res: any) => {
            if (res.Key && res.Key != 0) {
                this.wizard.OfferHeaderKey = res.Key;
                this.wizard.VersionNo = res.versionNo;

                var reportRefKeys = [];
                var reportSecRefKeys = [];
                reportRefKeys.push(res.Key);
                reportSecRefKeys.push(res.versionNo);

                //reportingService.printAutomaticReportsInQueue(21, reportRefKeys, reportSecRefKeys);
                //TODO 
                this.reportingService.printAutomaticReportsInQueueByProcess(21, this.wizard.ProcessCode, this.wizard.ProductCode, reportRefKeys, reportSecRefKeys);
            }
            this.toastrService.success(this.translate.instant("Offer printed successfully.")); 

        }); 
    }

    transformCheck(checkOnly = false) {

        this.offerService.errorControls = [];
        this.offerService.scriptErrorControls = [];

        this.wizard.IsPolicy = true;
        var step;
        var selectedOfferCount = 0;
        var selectedOfferKey = null;
        var selectedOffer = null;
        var offerStepKey = null;
        var totalOfferCount = 0;
        this.spinner.show();

        //check if an offer is selected.
        for (var stepKey in this.wizard.Steps) {
            if (this.wizard.Steps[stepKey].Type == 'Offer') {
                for (var offerKey in this.wizard.Steps[stepKey].Offers) {
                    totalOfferCount = totalOfferCount + 1;
                    if (this.wizard.Steps[stepKey].Offers[offerKey].Selected) {
                        if (!selectedOffer) {
                            selectedOffer = this.wizard.Steps[stepKey].Offers[offerKey];
                            selectedOfferKey = offerKey;
                            offerStepKey = stepKey;
                        }
                        selectedOfferCount = selectedOfferCount + 1;
                    }
                }
            }
        }

        if (totalOfferCount == 1 && selectedOfferCount == 0) {
            selectedOffer = this.wizard.Steps[stepKey].Offers[offerKey];
            selectedOfferKey = offerKey;
            offerStepKey = stepKey;
            selectedOfferCount = 1;
            selectedOffer.Selected = true;
        }

        //if an offer is selected, validate the controls for policy
        if (selectedOfferCount == 1) {

            //first validate the selected offer
            for (var stepKey in this.wizard.Steps) {
                if (this.wizard.Steps[stepKey].Type === "Offer") {
                    for (offerKey in this.wizard.Steps[stepKey].Offers) {
                        if (offerKey == selectedOfferKey) {
                            for (var sectionKey in this.wizard.Steps[stepKey].Offers[offerKey].Sections) {
                                var covers = this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Covers;
                                for (var coverKey in covers) {
                                    var coverControls = covers[coverKey].Controls;
                                    this.offerService.validateControls(coverControls);
                                }
                            }
                        }
                    }
                }
            }

            if (this.offerService.scriptErrorControls.length > 0) {
                this.spinner.hide();
                this.toastrService.error(this.translate.instant("Please correct the validation errors to proceed."));
                return false;
            }
            else if (this.offerService.errorControls.length > 0) {
                this.spinner.hide();
                this.toastrService.error(this.translate.instant("Please provide all the required values."));
                return false;
            }

            this.getClientData();

            for (var stepKey in this.wizard.Steps) {

                //standard controls
                this.offerService.validateControls(this.wizard.Steps[stepKey].Controls);
                //Group Controls
                for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                    var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
                    this.offerService.validateControls(controls);
                }

                //Section Controls
                var sections = this.wizard.Steps[stepKey].Sections;
                for (var sectionKey in sections) {
                    //Section standard controls
                    this.offerService.validateControls(sections[sectionKey].Controls);
                    //Section Group Controls
                    for (var groupKey in sections[sectionKey].ControlGroups) {
                        var controls = sections[sectionKey].ControlGroups[groupKey].Controls;
                        this.offerService.validateControls(controls);
                    }

                    //Cover Controls within Sections
                    var covers = this.wizard.Steps[stepKey].Sections[sectionKey].Covers;

                    for (var coverKey in covers) {
                        //Cover standard controls
                        this.offerService.validateControls(covers[coverKey].Controls);
                        //Cover Group Controls
                        for (var groupKey in covers[coverKey].ControlGroups) {
                            var controls = covers[coverKey].ControlGroups[groupKey].Controls;
                            this.offerService.validateControls(controls);
                        }
                    }
                }

                //offer controls
                if (this.wizard.Steps[stepKey].Type === "Offer") {

                    for (var offerKey in this.wizard.Steps[stepKey].Offers) {
                        for (var sectionKey in this.wizard.Steps[stepKey].Offers[offerKey].Sections) {
                            var sectionControls = this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Controls;
                            this.offerService.validateControls(sectionControls);

                            var covers = this.wizard.Steps[stepKey].Offers[offerKey].Sections[sectionKey].Covers;
                            for (var coverKey in covers) {
                                var coverControls = covers[coverKey].Controls;
                                this.offerService.validateControls(coverControls);
                            }
                        }
                    }
                }
                if (this.offerService.errorControls.length > 0) break;
            }
        }

        if (selectedOfferCount === 0) {
            this.toastrService.error(this.translate.instant("Please select an offer."));
            this.spinner.hide();
            return false;
        }
        else if (selectedOfferCount > 1) {
            this.toastrService.error(this.translate.instant("Only one offer can be selected to transform"));
            this.spinner.hide();
        }
        else if (this.offerService.scriptErrorControls.length > 0) {
            this.toastrService.error(this.translate.instant("Please correct the validation errors to proceed."));
            this.spinner.hide();
            return false;
        }
        else if (this.offerService.errorControls.length > 0) {
            delete this.wizard.Steps[offerStepKey].Offers;

            this.wizard.Steps[offerStepKey].Offers = {};
            this.offerCodes = [];
            this.wizard.Steps[offerStepKey].Offers[selectedOfferKey] = selectedOffer;
            this.offerCodes.push(selectedOffer.Code);

            this.toastrService.error(this.translate.instant("Please provide all the required values."));
            //this.setStep(offerStepKey);
            this.setStep(stepKey);

            //set wizard step
            var wizardIndex = this.wizardComponent.getIndexOfStepWithId(stepKey);
            this.wizardComponent.goToStep(wizardIndex);
            this.spinner.hide();

            return false;
        }
        else {
            delete this.wizard.Steps[offerStepKey].Offers;
            this.offerCodes = [];
            this.wizard.Steps[offerStepKey].Offers = {};
            this.wizard.Steps[offerStepKey].Offers[selectedOfferKey] = selectedOffer;
            this.offerCodes.push(selectedOffer.Code);
            if (!checkOnly) this.transformToPolicy();
            return true;
        }

    }

    directPayment() {

        //if (Object.keys(this.appliedDiscount).length === 0) {//no discount then continue
        //    this.checkCode();
        //}

        //chek if there is errors in offers
        var isError = false;
        for (var stepKey in this.wizard.Steps) {
            for (var offerKey in this.wizard.Steps[stepKey].Offers) {
                if (this.wizard.Steps[stepKey].Offers[offerKey].Error) {
                    isError = true;
                    break;
                }
            }
        }

        if (!isError)
            this.directPayClick.emit();
        else 
            this.toastrService.error(this.translate.instant("Unable to process your request. Please retry."));
    }
    
    transformToPolicy() {

        this.spinner.show();
        this.wizard.IsPolicy = true;
        this.apiService.post("Api/QuoteApi/Transform/", this.wizard).subscribe((res: any) => {
            if (res.row) {
                this.spinner.hide();
                this.toastrService.success(this.translate.instant("Offer transformed to Quote number") + " - " + res.row.ExternalCode);
                this.wizard.Policy = res.row;
                this.wizard.TransformStatusCde = 4;
                this.integrityCheck();
                this.wizard.IsView = (this.wizard.TransformStatusCde !== 0);
                this.wizard.IsPolicy = true;
                //this.router.reload();
            }
            else {
                this.wizard.IsPolicy = false;
                this.toastrService.error(res.Message);
            }
        });   
    }
    
    integrityCheck() {

        this.modalService.open(this.backendProcessModal, { centered: true, size: 'lg' });
        this.apiService.post("Api/QuoteApi/IntegrityCheck/", this.wizard.Policy).subscribe((res: any) => {
            if (res.rows) {
                this.wizard.checks = res.rows;
                this.wizard.checkStatus = res.StatusCode;
                this.modalService.dismissAll();
                this.modalService.open(this.checkListModal, { centered: true, size:'lg' });
            }
            else {
                this.toastrService.error(res.Message);
            }
        });   
    }



    intitateDirectPayment() {
        try {
            //initiate payment process
            let lightbox = window["Lightbox"]
            if (lightbox == null) {
                this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
                this.spinner.hide();
                this.router.navigate(["../Search"], { relativeTo: this.route });
                return;
            }

            this.apiService.post("Api/WebUserAPI/InitDirectPayment/",
                {
                    OfferHeaderKey: this.wizard.OfferHeaderKey,
                    VersionNo: this.wizard.VersionNo,
                    PolicyCde: this.wizard.Policy.PolicyKey
                }).subscribe((result: any) => {

                    if (result) {
                        let lightbox = window["Lightbox"]
                        if (lightbox == null) {
                            this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
                            return;
                        }
                        //var discountedTrxnAmt;
                        //if (Object.keys(this.appliedDiscount).length === 0) {
                        //    discountedTrxnAmt = result.AmountTrxn;
                        //}
                        //else {
                        //    if (this.appliedDiscount.PercentageIndicator) {
                        //        discountedTrxnAmt = Math.round((result.AmountTrxn - ((this.appliedDiscount.AmountValue / 100) * result.AmountTrxn)) * 1000) / 1000;//round 3 places;
                        //    }
                        //    else {
                        //        discountedTrxnAmt = Math.round((result.AmountTrxn - this.appliedDiscount.AmountValue) * 1000) / 1000;//round 3 places;
                        //    }
                        //}

                        lightbox.Checkout.configure = {
                            "MID": result.MID,
                            "TID": result.TID,
                            "AmountTrxn": result.AmountTrxn,
                            "MerchantReference": result.MerchantReference,
                            "TrxDateTime": result.TrxDateTime,
                            "SecureHash": result.SecureHash,
                            completeCallback: function (data) {
                                var event = new CustomEvent('onCompleteCallback', { detail: { "data": data } });
                                window.dispatchEvent(event);
                            },
                            errorCallback: function (error) {
                                var event = new CustomEvent('onErrorCallback', {});
                                window.dispatchEvent(event);
                            },
                            cancelCallback: function () {
                                var event = new CustomEvent('onCancelCallback', {});
                                window.dispatchEvent(event);
                            }
                        };
                        lightbox.Checkout.showLightbox();
                    } else {
                        this.spinner.hide();
                        this.router.navigate(["../Search"], { relativeTo: this.route });
                    }
                });
        } catch {
            this.spinner.hide();
            this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
        }
    }

    @HostListener('window:onErrorCallback', ['$event.detail'])
    errorCallback(detail) {
        this.spinner.hide();
        this.router.navigate(["../Search"], { relativeTo: this.route });
    }

    @HostListener('window:onCancelCallback', ['$event.detail'])
    cancelCallback(detail) {
        this.spinner.hide();
        this.router.navigate(["../Search"], { relativeTo: this.route });
    }

    @HostListener('window:onCompleteCallback', ['$event.detail'])
    completeCallback(detail) {
        let lightbox = window["Lightbox"]
        lightbox.Checkout.closeLightbox();
        this.toastrService.info(this.translate.instant("Payment successful, creating Policy. Please do not close/refresh browser."));
        this.spinner.show();

        var model = {
            "Wizard": this.wizard,
            "Account": { saveCard: false },
            "Response": JSON.stringify(detail.data)
        }

        this.router.navigate(["../../Home"], { relativeTo: this.route });
        this.apiService.post("Api/WebUserApi/DirectPayment/", model).subscribe((data: any) => {
            this.spinner.hide();
            var gatewayResponse = "";
            var message = "";
            if (data && data.PaymentResponseCode && data.PaymentResponseCode != "0") {
                gatewayResponse = this.translate.instant("Failure Reason") + ":" + data.PaymentResponseCode + " " + data.PaymentResponseMessage;
                Swal.fire({ text: gatewayResponse, type: 'danger' });
            }
            if (data == null) {
                message = this.translate.instant('Unable to process your request. Please retry.');
                Swal.fire({ text: message, type: 'danger' });
            }
            else if (data.AllocatedInd == 'Y') {
                var message = 'The policy has been successfully issued, policy number is 991. The payment processed succesfully, receipt number is 992. Referred policy documents have been sent to your email.';
                message = this.translate.instant(message);
                message = message.replace("991", data.PolExtCode).replace("992", data.ReceiptNumber);
                Swal.fire({ text: message, type: 'success' });

                this.reportingService.printProcess(this.wizard.ProcessCode,
                    this.wizard.ProductCode,
                    data.PolicyKey, 0, 31);
            }
            else {
                if (data.PaymentResponseCode == "0") //error in allocation or acceptance     
                {
                    message = 'Payment is successful. Your policy is not yet In Force. Please contact helpdesk with reference no:991';
                    message = this.translate.instant(message);
                    message = message.replace("991", data.PolExtCode);
                    Swal.fire({ text: message, type: 'info' });
                }
                else if (data.PaymentResponseCode != "") {
                    message = 'Unable to process the payment. Please contact helpdesk with reference no:991. 992';
                    message = this.translate.instant(message);
                    message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                    Swal.fire({ text: message, type: 'danger' });
                }
                else if (data.PaymentResponseCode == "") //not reached till payment
                {
                    if (data.PolExtCode == "") //not created quote
                    {
                        if (data.OfferExtCode == "") {
                            message = 'Unable to process your request. Please retry.';
                            message = this.translate.instant(message);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                        else //offer created       
                        {
                            message = 'Unable to process the payment. Please contact helpdesk. Your offer reference number is 991. 992';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                    }
                    else //quote created
                    {
                        if (data.IntegrityCheckStatusCode == "1" || data.IntegrityCheckStatusCode == "2" || data.IntegrityCheckStatusCode == "") {
                            message = 'Unable to process the payment. Please contact helpdesk. Your quote reference number is 991. 992';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                        else {
                            message = 'Policy integrity check failed. Please contact helpdesk. Your quote reference number is 991';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                    }
                }
            }

            this.modalService.dismissAll();
            this.router.navigate(["../Search"], { relativeTo: this.route });
        });

    }

    acceptPolicy() {

        //check payment method
        var control = this.getControlByeReferential("17");
        var useGateWay = false;
        if (control != null) {
            if (control.Value === "10") {
                useGateWay = true;
            }
        }
        else {
            control = this.getControlByeReferential("210");
            if (control != null) {
                if (control.Value === "10") {
                    useGateWay = true;
                }
            }
        }

        if (!this.insurancedXPortal && useGateWay) {
            this.spinner.show();
            this.intitateDirectPayment();
        }
        else {
            this.directAccept();
        }
    }

    directAccept() {
        this.toastrService.info("Accepting policy. Please do not close/refresh browser.");
        this.spinner.show();
        this.modalService.dismissAll();
        this.apiService.post("Api/QuoteApi/Accept/", this.wizard.Policy).subscribe((res: any) => {
            this.spinner.hide();
            if (res.row) { //success

                this.toastrService.success(this.translate.instant("Policy is accepted successfully. The new policy number is " + res.row.ExternalCode), res.row.ExternalCode);
                this.wizard.IsPolicy = true;
                this.reportingService.wizard = this.wizard;
                this.reportingService.printProcess(this.wizard.ProcessCode, this.wizard.ProductCode, this.wizard.Policy.PolicyKey, 0, 31);
                this.router.navigate(["../Search"], { relativeTo: this.route });
            }
            else { //failed
                this.wizard.IsPolicy = false;
                this.toastrService.error(res.Message);
                if (res.ExceptionMessage)
                    this.toastrService.error(res.ExceptionMessage);
            }
        }); 
    }

    //Not used yet
    getClientData() {
        var model = {
            IsCompany: this.wizard.IsCompany,
            ClientKey: this.wizard.ClientKey,
            Address: {
                Address1: "",
                Address2: "",
                Address3: "",
                Address4: "",
                CountryCde: "",
                TownCde: "",
                PostalCde: "",
               },
            Addresses: {},
            First: "",
            Email: "",
            WorkTelephone: "",
            MobileTelephone: "",
            CompanyRegistrationNo: "",
            IDNumber: "",
            CompanyIncomeTaxNo: "",
            CompanyName: "",
            SurName: "",
            BirthDate: "",
            TitleCode: ""
    };


        if (this.wizard.Addresses && this.wizard.Addresses[this.wizard.ClientKey])
        model.Addresses = this.wizard.Addresses[this.wizard.ClientKey].rows;

        for (var stepKey in this.wizard.Steps) {
            for (var controlKey in this.wizard.Steps[stepKey].Controls) {
            var control = this.wizard.Steps[stepKey].Controls[controlKey];
            if (!control) continue;
            switch (control.Properties.SystemName.Value) {
                case "Client.OtherName":
                    model.First = control.Value;
                    break;
                case "Client.Address2":
                    model.Address.Address2 = control.Value;
                    break;
                case "Client.Address3":
                    model.Address.Address3 = control.Value;
                    break;
                case "Client.Address4":
                    model.Address.Address4 = control.Value;
                    break;
                case "Client.CountryCode":
                    model.Address.CountryCde = control.Value;
                    break;
                case "Client.TownCode":
                    model.Address.TownCde = control.Value;
                    break;
                case "Client.PostalCode":
                    model.Address.PostalCde = control.Value;
                    break;
                case "Client.Email":
                    model.Email = control.Value;
                    break;
                case "Client.Work":
                    if (this.wizard.IsCompany == "Y")
                        model.WorkTelephone = control.Value;
                    else
                        model.MobileTelephone = control.Value;
                    if (this.wizard.IsPolicy && this.wizard.IsCompany == "Y" && !control.Value) {
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.Mobile":
                    if (this.wizard.IsCompany == "Y")
                        model.WorkTelephone = control.Value;
                    else
                        model.MobileTelephone = control.Value;
                    if (this.wizard.IsPolicy && this.wizard.IsCompany == "Y" && !control.Value) {
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.Address1":
                    model.Address.Address1 = control.Value;
                    if (this.wizard.IsPolicy && !control.Value) {
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.IDNumber":
                    if (this.wizard.IsCompany == "Y")
                        model.CompanyRegistrationNo = control.Value;
                    else
                        model.IDNumber = control.Value;
                    if (this.wizard.IsPolicy && !control.Value) {
                        control.Properties['PolicyReadOnly'].Value = false;
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.IncomeTaxNo":
                    model.CompanyIncomeTaxNo = control.Value;
                    if (this.wizard.IsPolicy && this.wizard.IsCompany == "Y" && !control.Value) {
                        control.Properties['PolicyReadOnly'].Value = false;
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.SurName":
                    if (this.wizard.IsCompany == "Y")
                        model.CompanyName = control.Value;
                    else
                        model.SurName = control.Value;
                    if (!control.Value) {
                        control.Properties['OfferReadOnly'].Value = false;
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.DateOfBirth":
                    model.BirthDate = control.Value;
                    if (this.wizard.IsPolicy && this.wizard.IsCompany != "Y" && !control.Value) {
                        control.Properties['PolicyVisible'].Value = true;
                        control.Properties['PolicyReadOnly'].Value = false;
                        this.offerService.errorControls.push(control);
                        control.hasError = true;
                    }
                    break;
                case "Client.TitleCode":
                    model.TitleCode = control.Value;
                    break;
            }
        }
    }

    return model;
}

    openFileBrowse(docCode) {
        let element: HTMLElement = document.getElementById("document"+docCode) as HTMLElement;
        element.click();
    }

    fileChange(documentCode, event) {
        var file: File = event.target.files[0];
        var myReader: FileReader = new FileReader();

        if (file.type != 'image/jpeg' && file.type != 'image/png') {
            this.toastrService.error(this.translate.instant('Only image of type "png" and "jpg" are allowed'), this.translate.instant('Upload Failed'));
        } else {
            myReader.onloadend = (e) => {
                this.wizard.Documents[documentCode].Image = myReader.result;
                this.wizard.Documents[documentCode].ImageName = file.name;
                this.wizard.Documents[documentCode].ImageType = file.name.substr(file.name.lastIndexOf('.'));
                this.wizard.Documents[documentCode].File = file;
            }
            myReader.readAsDataURL(file);
        }
    }

    removeDoc(index) {
        this.wizard.Documents[index].Image = "";
        this.wizard.Documents[index].ImageType = "";
        this.wizard.Documents[index].ImageName = "";
        this.wizard.Documents[index].File = "";
    }

    CheckValue(coverCode) {
        this.isExpandedOfferCover = coverCode;
        console.log("isExpanded: " + this.isExpandedOfferCover + " Cover Code:" + coverCode);
        
    }
   
    refreshSummary() {
        var isSummary = false;
        if (this.wizard.Summaries) {
            for (var summary in this.wizard.Summaries) {
                isSummary = true;
                break;
            }
        }
        if (!isSummary) return;
        //multiline group changed so refresh process summary
        this.apiService.post("Api/PolicyAPI/RefreshSummary/", this.wizard).subscribe((result: any) => {
            this.wizard.Summaries = result;
        });
    }

    getControlBySystemName(systemName) {
        var referential = {};
        for (var stepKey in this.wizard.Steps) {

            var controls = this.wizard.Steps[stepKey].Controls;
            for (var controlKey in controls) {
                if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                    return controls[controlKey];
                }
            }

            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                        return controls[controlKey];
                    }
                }
            }

            for (var transKey in this.wizard.Steps[stepKey].ClaimTransacReferences) {
                for (var groupKey in this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups) {
                    var controls = this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups[groupKey].Controls;
                    for (var controlKey in controls) {
                        if (controls[controlKey].Properties["SystemName"].Value == systemName) {
                            return controls[controlKey];
                        }
                    }
                }

            }
        }
        return null;
    }

    getControlByeReferential(referential) {
        for (var stepKey in this.wizard.Steps) {

            var controls = this.wizard.Steps[stepKey].Controls;
            for (var controlKey in controls) {
                if (controls[controlKey].Referential == referential) {
                    return controls[controlKey];
                }
            }

            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                var controls = this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls;
                for (var controlKey in controls) {
                    if (controls[controlKey].Referential == referential) {
                        return controls[controlKey];
                    }
                }
            }

            for (var transKey in this.wizard.Steps[stepKey].ClaimTransacReferences) {
                for (var groupKey in this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups) {
                    var controls = this.wizard.Steps[stepKey].ClaimTransacReferences[transKey].ControlGroups[groupKey].Controls;
                    for (var controlKey in controls) {
                        if (controls[controlKey].Referential == referential) {
                            return controls[controlKey];
                        }
                    }
                }

            }
        }
        return null;
    }
    checkCode() {
        if (this.offerService.offerHeaderKey === '') {
            if (this.checkCodeSave == true) {
                this.toastrService.error('System Failed to Apply Discount Please Contact System Administrator.', 'Error');
                console.log("offer key: " + this.offerService.offerHeaderKey);
                return;
            }
            this.checkCodeSave = true;
            this.save();
            return;
        }
        

        var model = {
            CheckCode: this.DiscountCode,
            OffHeaderCode: this.offerService.offerHeaderKey,
            OffVersion: this.offerService.versionNo
        };

        this.apiService.post('Api/DxDiscountApi/CheckCode/', model).subscribe(
            (res: any) => {
                if (res.row == null) {
                    this.toastrService.error('Unable to get Discount', 'Apply Discount');
                    this.appliedDiscount = {};
                }
                else {
                    this.appliedDiscount = res.row;

                    this.toastrService.success("Discount Applied With " + res.row.AmountValue + " " + ( res.row.PercentageIndicator ? " Percent " : " Dinars "));
                }

                this.offerService.appliedDiscount = this.appliedDiscount;//the gateway uses this for discount
            },
            (error: any) => {
                this.toastrService.error(error.Message || 'Failed to Apply Discount', 'Error');
                this.appliedDiscount = {};
            }
        );
    }

    getDiscountedOfferDetails(offerDetails) {
        var test = offerDetails;
        if (Object.keys(this.appliedDiscount).length === 0) {//no discount applied
            return offerDetails.Value;
        }
        else {
            var discountedValue;
            if (this.appliedDiscount.PercentageIndicator) {
                discountedValue = Math.round((offerDetails.Value - ((this.appliedDiscount.AmountValue / 100) * offerDetails.Value)) * 1000) / 1000;//round 3 places
            }
            else {
                //discountedValue = offerDetails.Value - this.appliedDiscount.AmountValue;
                discountedValue = Math.round((offerDetails.Value - this.appliedDiscount.AmountValue) * 1000) / 1000;//round 3 places
            }
            return discountedValue;
        }
    }
    getDiscountedOfferDetailsTitle(offerDetails) {
        var test = offerDetails;
        
        if (Object.keys(this.appliedDiscount).length === 0) {//no discount applied
            return offerDetails.Title;
        }
        else {
            return (offerDetails.Title + ", " + this.translate.instant("Discount") + " " + (this.appliedDiscount.PercentageIndicator ? this.translate.instant("Percentage") : this.translate.instant("Amount")) + ":" + this.appliedDiscount.AmountValue);
        }
    }

    applyPromotion(offerDetails) {
        var model = {
            PromotionCode: offerDetails.PromotionCode.trim()
        };

        this.apiService.post('Api/PromotionAPI/CheckPromotion/', model).subscribe((res: any) => {
            if (res.row == null) {
                this.toastrService.error('Invalid promotion code');
                this.appliedPromotion = {};
                offerDetails.PromotionKey = null;
                offerDetails.PromotionCode = null;
                offerDetails.PromotionDesc = null;
                offerDetails.DiscountType = null;
                offerDetails.DiscountValue = null; 
                offerDetails.DiscountAmount = 0;
                offerDetails.DiscountedValuePromo = offerDetails.Value - offerDetails.DiscountAmount;
            } else {
                this.appliedPromotion = res.row; 
                var discountedValue;
                var discountAmount; 
                if (this.appliedPromotion.DiscountType == "P") {
                    discountedValue = this.decimalPipe.transform((offerDetails.Value - ((this.appliedPromotion.DiscountValue / 100) * offerDetails.Value)), this.decimals); //round 3 places
                }
                else {
                    //discountedValue = offerDetails.Value - this.appliedDiscount.AmountValue;
                    discountedValue = this.decimalPipe.transform((offerDetails.Value - this.appliedPromotion.DiscountValue), this.decimals);//round 3 places
                }

                discountAmount = this.decimalPipe.transform((offerDetails.Value - discountedValue), this.decimals);
                this.toastrService.success("Discount Applied Successfully");
                //return discountedValue;
                offerDetails.PromotionKey = this.appliedPromotion.PromotionKey;
                offerDetails.PromotionCode = this.appliedPromotion.PromotionCode;
                offerDetails.PromotionDesc = this.appliedPromotion.Description;
                offerDetails.DiscountType = this.appliedPromotion.DiscountType;
                offerDetails.DiscountValue = this.appliedPromotion.DiscountValue; 
                offerDetails.DiscountAmount = discountAmount;
                offerDetails.DiscountedValuePromo = discountedValue;
                //console.log(offerDetails);
            }

        }); 
    }
}
